import { css } from "styled-components";
import { DefaultButtonProps } from "../Button.types.js";
import { getColor } from "./getColor.js";

export const textGradient = ({ color }: Pick<DefaultButtonProps, "color">) => {
    return css`
        background: ${(props) => getColor({ color, value: "100", ...props })};
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    `;
};
